interface ISpinnerProps {
  relative?: boolean;
  style?: React.CSSProperties;
}

const Spinner = ({ relative = false, style = {} }: ISpinnerProps) => {
  const DaSpinner = () => (
    <svg
      className="absolute left-1/2 top-1/2 z-50 animate-spin -ml-1 mr-3 h-10 w-10 text-green-600"
      xmlns="http://www.w3.org/2000/svg"
      fill="none"
      viewBox="0 0 24 24"
      style={{ ...style }}
    >
      <circle
        className="opacity-25"
        cx="12"
        cy="12"
        r="10"
        stroke="currentColor"
        strokeWidth="4"
      ></circle>
      <path
        className="opacity-75"
        fill="currentColor"
        d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"
      ></path>
    </svg>
  );

  return relative ? (
    <div className="relative mb-10 mr-10 sm:ml-4">
      <DaSpinner />
    </div>
  ) : (
    <DaSpinner />
  );
};

export default Spinner;
